import { FieldProps, RawMaterialProps } from "enums/RawMaterialEnums";
import { FormikContextType } from "formik";
import { rawMaterialPayload } from "views/CreateProductFlow/CreateProductFlowInterfaces";

export const validateForHandleSave = async(formikProps: FormikContextType<rawMaterialPayload>, handleSaveAsDraft?:(payload: rawMaterialPayload) => void)=>{
    const { validateForm, isValid, values, setFieldTouched } = formikProps;
    const isValidated = await validateForm();

    if(isValidated.ingredients?.length){
      Array.isArray(isValidated.ingredients) &&
      isValidated.ingredients.forEach((_,index)=>{
        setFieldTouched(`${RawMaterialProps.INGREDIENTS}[${index}].${FieldProps.INGREDIENT_NAME}`, true,true)
        setFieldTouched(`${RawMaterialProps.INGREDIENTS}[${index}].${FieldProps.INGREDIENT_QUANTITY}`, true,true)
        setFieldTouched(`${RawMaterialProps.INGREDIENTS}[${index}].${FieldProps.INGREDIENT_ORIGIN}`, true,true)
        setFieldTouched(`${RawMaterialProps.INGREDIENTS}[${index}].${FieldProps.INGREDIENT_REGION}`, true,true)
        setFieldTouched(`${RawMaterialProps.INGREDIENTS}[${index}].${FieldProps.INGREDIENT_UNIT}`, true,true)
      })
    }
    if(isValidated.packageMaterials?.length){
      Array.isArray(isValidated.packageMaterials) && 
      isValidated.packageMaterials.forEach((_,index)=>{
        setFieldTouched(`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${FieldProps.PACKAGING_NAME}`, true,true)
        setFieldTouched(`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${FieldProps.PACKAGING_QUANTITY}`, true,true)
        setFieldTouched(`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${FieldProps.PACKAGING_REGION}`, true,true)
        setFieldTouched(`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${FieldProps.PACKAGING_ORIGIN}`, true,true)
        setFieldTouched(`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${FieldProps.PACKAGING_UNITS_PER_PACKAGING}`, true,true)
        setFieldTouched(`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${FieldProps.PACKAGING_UNIT}`, true,true)
      })
    }
    if (Object.keys(isValidated).length === 0) {
      handleSaveAsDraft?.(values);
    }
  }